import React, { useEffect, useMemo, useState } from 'react';
import { Button, Box, Autocomplete, TextField, Typography } from '@mui/material';
import Swal from 'sweetalert2';
import { apiPostForm, apiPutForm } from '../../../../functions/api';
import { useSelector } from 'react-redux';

export default function AsignarEquipo({ data, show, handleClose, reload, users = [], mode }) {
    const auth = useSelector((state) => state.authUser.access_token);
    const [selectedUser, setSelectedUser] = useState(null);

    const tieneGrupo = Boolean(data?.grupo_id);

    const esPrincipal = useMemo(() => {
        if (!data?.grupo_id) return false;

        const id = Number(data?.id);
        const gpidRaw = data?.grupo_principal_id;

        // ✅ si no viene grupo_principal_id, asumimos que el item que abre el modal es el principal
        if (gpidRaw === null || gpidRaw === undefined) return true;

        const gpid = Number(gpidRaw);
        return id === gpid;
    }, [data]);


    const asignacionId = useMemo(() => {
        return (
            data?.asigna?.id ||
            data?.asigna_id ||
            data?.asignacion_id ||
            data?.raw?.asigna?.id ||
            null
        );
    }, [data]);

    useEffect(() => {
        if (show) setSelectedUser(null);
    }, [show, data]);

    const titulo = mode === 'reasignar' ? 'Reasignar Equipo' : 'Asignar Equipo';

    const handleSubmit = async () => {



        if (mode === 'asignar' && !data?.disponible) {
            Swal.fire('Ya está asignado', '', 'info');
            return;
        }

        if (!selectedUser) {
            Swal.fire('Selecciona un usuario', '', 'warning');
            return;
        }

        try {
            // ==========================
            // ✅ ASIGNAR
            // ==========================
            if (mode === 'asignar') {


                console.log('DATA CHECK:', {
                    id: data?.id,
                    grupo_id: data?.grupo_id,
                    grupo_principal_id: data?.grupo_principal_id,
                    tieneGrupo,
                    esPrincipal,
                });
                const payload = (tieneGrupo && esPrincipal)
                    ? { modo: 'GRUPO', grupo_id: data.grupo_id, persona: selectedUser.id }
                    : { modo: 'INDIVIDUAL', equipoId: data.id, persona: selectedUser.id };

                console.log('ASIGNAR:', payload);

                await apiPostForm(`equipos/asignar`, payload, auth);

                await Swal.fire({
                    icon: 'success',
                    title: (tieneGrupo && esPrincipal) ? 'Grupo asignado' : 'Equipo asignado',
                    showConfirmButton: false,
                    timer: 1400,
                    timerProgressBar: true,
                });

                handleClose();
                reload();
                return;
            }

            // ==========================
            // ✅ REASIGNAR
            // ==========================
            if (mode === 'reasignar') {
                // principal => grupo
                if (tieneGrupo && esPrincipal) {
                    const payload = { modo: 'GRUPO', grupo_id: data.grupo_id, nuevaPersona: selectedUser.id };
                    console.log('REASIGNAR (GRUPO):', payload);

                    await apiPutForm(`equipos/reasignar/${data.id}`, payload, auth);

                    await Swal.fire({
                        icon: 'success',
                        title: 'Grupo reasignado',
                        showConfirmButton: false,
                        timer: 1400,
                        timerProgressBar: true,
                    });

                    handleClose();
                    reload();
                    return;
                }

                // accesorio => individual
                if (!asignacionId) {
                    Swal.fire(
                        'No encontré la asignación actual',
                        'Necesito data.asigna.id para reasignar individual.',
                        'warning'
                    );
                    return;
                }

                const payload = {
                    modo: 'INDIVIDUAL',
                    equipo: asignacionId,
                    equipo_id: data.id,
                    nuevaPersona: selectedUser.id,
                };

                console.log('REASIGNAR (INDIVIDUAL):', payload);

                await apiPutForm(`equipos/reasignar/${data.id}`, payload, auth);

                await Swal.fire({
                    icon: 'success',
                    title: 'Equipo reasignado',
                    showConfirmButton: false,
                    timer: 1400,
                    timerProgressBar: true,
                });

                handleClose();
                reload();
            }
        } catch (error) {
            console.error(error);
            Swal.fire('Error', error?.response?.data?.message || 'Ocurrió un error', 'error');
        }
    };

    if (!show) return null;

    return (
        <Box sx={modalStyle}>
            <Typography variant="h6" fontWeight={900} mb={1}>
                {titulo}
            </Typography>

            {/* ✅ Aviso si es principal */}
            {tieneGrupo && esPrincipal ? (
                <Typography variant="caption" sx={{ display: 'block', mb: 1, fontWeight: 800, color: 'warning.main' }}>
                    Este equipo es PRINCIPAL del grupo {data.grupo_id}. {mode === 'asignar' ? 'Se asignará TODO el grupo.' : 'Se reasignará TODO el grupo.'}
                </Typography>
            ) : null}

            <Autocomplete
                disablePortal
                options={users}
                getOptionLabel={(u) => `${u.nombre} ${u.apellido_paterno} ${u.apellido_materno}`}
                onChange={(e, value) => setSelectedUser(value)}
                renderInput={(params) => <TextField {...params} label="Usuario" />}
                slotProps={{
                    popper: { sx: { zIndex: 3000 } },
                }}
            />

            <Box mt={2} display="flex" gap={2} justifyContent="flex-end">
                <Button variant="contained" onClick={handleSubmit} disabled={!selectedUser}>
                    {mode === 'reasignar'
                        ? (tieneGrupo && esPrincipal ? 'Reasignar grupo' : 'Reasignar')
                        : (tieneGrupo && esPrincipal ? 'Asignar grupo' : 'Asignar')}
                </Button>

                <Button variant="outlined" onClick={handleClose}>
                    Cerrar
                </Button>
            </Box>
        </Box>
    );
}

const modalStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    width: 420,
    transform: 'translate(-50%, -50%)',
    bgcolor: '#fff',
    p: 4,
    boxShadow: 24,
    borderRadius: 2,
    zIndex: 2000,
};
